import React from 'react';
import {ThemeProvider} from 'twenty-ui/theme';
import 'twenty-ui/theme-light.css';
import 'twenty-ui/style.css';
import './theme/tokens.css';
import './ui.css';
import './motion.css';
import {twentyOverrides} from './theme/twenty-overrides.mjs';
export function UIProvider({children,overrides={},className}){
 return <ThemeProvider colorScheme="light" applyToRoot overrides={{...twentyOverrides,...overrides}} className={className}>{children}</ThemeProvider>;
}
export default UIProvider;
